export default __webpack_public_path__ + "assets/424775514f278a2e4640cd5e39a4a5ea.png";